import { Box } from '@everlywell/ui-kit';
import AccordionCard, { AccordionCardProps } from 'components/AccordionCard';
import { SectionHeader } from 'components/SectionHeader';
import React from 'react';

interface OrganizationCardsSectionProps {
  title: string;
  headline: string;
  listOfContentWithImages: AccordionCardProps[];
}

export default function OrganizationCardsSection({
  title,
  headline,
  listOfContentWithImages,
}: OrganizationCardsSectionProps) {
  return (
    <Box
      pb={['3rem', '4rem', '5rem']}
      pt={2}
      px={4}
      maxWidth="1200px"
      mx="auto"
    >
      <SectionHeader
        eyebrow={title}
        title={headline}
        titleMaxWidth="850px"
        align="center"
      />

      <Box
        display="flex"
        flexDirection={['column', 'column', 'row']}
        gap={2}
        mt={12}
      >
        {listOfContentWithImages.map((item) => (
          <Box flex="1" height="540px" className="accordion-card">
            <AccordionCard
              backgroundColor={item.backgroundColor}
              cta={item.cta}
              heading={item.heading}
              description={item.description}
              image={item.image}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
